import { render } from "./OverlayPanel.vue?vue&type=template&id=6913e8e0"
import script from "./OverlayPanel.vue?vue&type=script&lang=js"
export * from "./OverlayPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__